'use client';

import type { ReactNode } from 'react';

import { FeatureFlagProvider as ClientProvider } from '@/feature-flags/client/provider';
import { getFeatureFlagConfig } from '@/feature-flags/config';

export function FeatureFlagProvider({ children }: { children: ReactNode }) {
  const config = getFeatureFlagConfig();

  return <ClientProvider config={config}>{children}</ClientProvider>;
}
